export default __webpack_public_path__ + "static/media/habrImg2.2f1abc2c.jpeg";